// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_e6-3";
export var flatBottomCorners = "_e6-5";
export var productImage = "_e6-0";
export var quantityContainer = "_e6-2";
export var quantityHeader = "_e6-6";
export var tooltip = "_e6-1";
export var wrapAndEllipsesOverflow = "_e6-4";